export default "__VITE_ASSET__DuRfTx2T__"